"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatGDD = exports.formatTimeSlot = exports.tmsToFormat = void 0;
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var Date_1 = require("../../Constants/Date");
var locale_1 = require("date-fns/locale");
(0, date_fns_1.setDefaultOptions)({ locale: locale_1.fr });
var tmsToFormat = function (tms, formatString) {
    if (!tms)
        return undefined;
    var date = tms instanceof Date ? tms : (0, date_fns_1.fromUnixTime)(tms);
    var adjustedFormatString = date.getMinutes() === 0 ? (formatString || 'eeee dd MMMM').replace('mm', '') : (formatString || 'eeee dd MMMM');
    return (0, date_fns_tz_1.formatInTimeZone)(date, Date_1.timeZone, adjustedFormatString);
};
exports.tmsToFormat = tmsToFormat;
var formatTimeSlot = function (timeSlot, options) {
    var _a = options || {}, _b = _a.condensed, condensed = _b === void 0 ? false : _b, _c = _a.showHours, showHours = _c === void 0 ? false : _c, _d = _a.theorical, theorical = _d === void 0 ? false : _d;
    if (!timeSlot || !timeSlot.startHour || !timeSlot.endHour)
        return 'Indisponible';
    var date = timeSlot.date, startHour = timeSlot.startHour, endHour = timeSlot.endHour, theoricalDate = timeSlot.theoricalDate;
    var dateFormat = condensed ? 'eee dd MMM' : 'eeee dd MMMM';
    var dateFormatted = (0, exports.tmsToFormat)(theorical ? theoricalDate : date, dateFormat) || 'Indisponible';
    if (condensed)
        return dateFormatted;
    if (showHours) {
        var startHourFormatted = (0, exports.tmsToFormat)(startHour, 'HH\'h\'mm');
        var endHourFormatted = (0, exports.tmsToFormat)(endHour, 'HH\'h\'mm');
        return "".concat(dateFormatted, " entre ").concat(startHourFormatted, " et ").concat(endHourFormatted);
    }
    return dateFormatted;
};
exports.formatTimeSlot = formatTimeSlot;
var formatGDD = function (gdd, options) {
    var _a;
    var _b = options || {}, _c = _b.condensed, condensed = _c === void 0 ? false : _c, _d = _b.showHours, showHours = _d === void 0 ? false : _d;
    if (!gdd || !gdd.dayLabel)
        return 'Indisponible';
    var dayLabel = (_a = gdd.dayLabel) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (condensed)
        return "les ".concat(dayLabel, "s");
    if (showHours) {
        var startHour = (0, exports.tmsToFormat)(gdd.startHour, 'HH\'h\'mm');
        var endHour = (0, exports.tmsToFormat)(gdd.endHour, 'HH\'h\'mm');
        return "tous les ".concat(dayLabel, "s, entre ").concat(startHour, " et ").concat(endHour);
    }
    return "tous les ".concat(dayLabel, "s");
};
exports.formatGDD = formatGDD;
exports.default = { tmsToFormat: exports.tmsToFormat, formatTimeSlot: exports.formatTimeSlot, formatGDD: exports.formatGDD };
//# sourceMappingURL=DateFormat.js.map